export const currentVersion = 1;
export var ContentAsCodeType;
(function (ContentAsCodeType) {
    ContentAsCodeType["CHART"] = "chart";
    ContentAsCodeType["DASHBOARD"] = "dashboard";
    ContentAsCodeType["SQL_CHART"] = "sql_chart";
    ContentAsCodeType["SPACE"] = "space";
})(ContentAsCodeType || (ContentAsCodeType = {}));
//# sourceMappingURL=coder.js.map